'use strict';

module.exports = {
  attributes: {
    resetPasswordToken: {
      hidden: true,
    },
    confirmationToken: {
      hidden: true,
    },
    provider: {
      hidden: true,
    },
  },
};
